module.exports = __webpack_public_path__ + "img/Nutrition-Logo.60496c40.png";